export const LISTBOX_ID = 'search-bar-dropdown-listbox';